import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../generics/help';
import {Table} from 'react-bootstrap';
import { pencil2 } from 'react-icons-kit/icomoon/pencil2';
import { bin } from 'react-icons-kit/icomoon/bin';
import {search} from 'react-icons-kit/icomoon/search';
import SvgIcon from 'react-icons-kit';
import ModalNew from './ModalNew';
import { getDateHour, convokePlacesOption, donationTypeExtraction, getColumnsList, preOffersList, preOffersSearch, preOffersDelete } from '../../libs/services';
import { getFormatHour } from '../../libs/functions';

var Config = require('../../config');

class DiaryList extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.handleChangeFilter = this.handleChangeFilter.bind(this);
		this.eventAgenda = this.eventAgenda.bind(this);
		this.onRegister = this.onRegister.bind(this);
		this.newEvent = this.newEvent.bind(this);
		this.getList = this.getList.bind(this);
		this.deletePre = this.deletePre.bind(this);

		this.state = {
			events:[],
			show_all:false,
			start_date:"",
			convoke_place: "",
			convoke_places: [],
			extraction_type: "",
			extraction_types: [],
			hf_id: sessionStorage.getItem('health_facilities_id'),
			columns:[],
			hours:[]
		}
	}

	async componentDidMount() {
		var response = await getDateHour();

		if(response !== undefined){
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = getFormatHour(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0]
			});
		}
		  
		response = await convokePlacesOption('operatives', this.state.hf_id);

		if(response !== undefined){
			this.setState({ convoke_places: response });
		}

		response = await donationTypeExtraction("no_cells");

		if(response !== undefined){
			this.setState({ extraction_types: response });
		}

		response = await getColumnsList('PRE_OFFERS');

		if(response !== undefined){
			this.setState({ columns: response });
		}
		
	}	

	async getList(option, startHour, endHour){
		
		var response = await preOffersList(
						option, this.state.start_date, startHour, endHour, this.state.hf_id, this.state.convoke_place, 
						this.state.extraction_type, this.props.waiting
					);

		if(response !== undefined){
			var events = [];
			response.map((res, i)=>{
				var date = moment(res.timestamp_date).format('YYYY-MM-DD');

				events.push({
					id:res.id,
					title:res.donor,
					donation_type:res.donation_type,
					extraction_type:res.extraction_type,
					//start:new Date(date+' '+res.timestamp_hour),
					start:moment(date).format('DD/MM/YYYY'),
					hour:moment(res.timestamp_hour, 'H:mm:ss').format('HH:mm'),
					//end:new Date(date+' '+res.timestamp_hour),
					status:res.status,
					color:res.status === "" ? '#3174ad' : '#31ad6e',
					folio: res.folio
				});
			})
			this.setState({events:events});
		}
	}

	onRegister(e){
		var id = e.target !== undefined ? e.target.id : e;
		this.props.history.push('/offers/register/'+id);
	}

	eventAgenda(props){
        return <div style={{display:'flex'}}>
	        <div style={{width:'77%'}}>
	        	<em>
	        		{props.event.title+' - '+props.event.extraction_type+' - '+props.event.donation_type}
	        	</em>
	        </div>
	        <div style={{width:'15%'}}>
	        	<em>
	        		{props.event.status}
	        	</em>
	        </div>
	        <div style={{width:'8%'}}>
	        	{props.event.status === "" ?
	        		<button className="btn btn-info" id={props.event.id} onClick={(e)=> this.onRegister(e)}>Registro</button>

	        	:null}
	        </div>
        </div>
    }

    newEvent(e, hour){
		e.preventDefault();
		this.modal_new.handleShow(this.state.start_date, hour, null);
    }

    handleChange(e){
    	this.setState({
    		[e.target.name]: e.target.value
    	});
		document.getElementById(e.target.id).classList.remove('error');
		
    }

	async onSearch(e){
		if (this.state.convoke_place !== "" && this.state.extraction_type !== "")
		{
			
			document.getElementById('convoke_place').classList.remove('error');
			document.getElementById('extraction_type').classList.remove('error');
						
			var response = await preOffersSearch(this.state.start_date, this.state.convoke_place, this.state.extraction_type);

			if(response !== undefined){
				this.setState({ hours: response });
				this.getList("all","00:00","23:59");
			}else{
				this.setState({ hours: [], events:[] });
			}

		}else{
			if(this.state.convoke_place === ""){
				document.getElementById('convoke_place').classList.add('error');
			}

			if(this.state.extraction_type === ""){
				document.getElementById('extraction_type').classList.add('error');
			}

			swal('Error', 'Campos incompletos', 'error');
		}
	}

	handleChangeFilter(e){
    	this.setState({
    		[e.target.name]: e.target.value
    	});

		if(e.target.value === "all"){
			this.getList("all", "00:00","23:59");
		}else{
			var hourItem = this.state.hours[e.target.value];
			this.getList("hour",hourItem.start,hourItem.end);
		}
    }

    editPre(id){
    	//this.props.history.push('/event/edit/'+id);
		this.modal_new.handleShow(null,null,id);
    }

    deletePre(id){
    	swal({
	        title: '¿Está seguro?',
	        text: '¿Desea eliminar este registro?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
    	}, async (isConfirm)=> {
        	if (isConfirm) {
				var res = await preOffersDelete(id);

				if(res !== undefined){
					swal('Buen Trabajo', 'Registro Eliminado','success');
					this.getList("all", "00:00", "23:59");
				}          		
        	}
    	});
    }

	showColumn(column_name){
		for(var i =0; i < this.state.columns.length;i++){
			if(this.state.columns[i]=== column_name){
				return false;
		  }
		}

	  return true;
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						Agenda
					</h5>
				</div>
				
				<Help 
					{...this.props}
					menu={"help_donors"} 
					submenu={"help_pre_offers"}  />

				<div className="col-xs-12 form-group">
					<div className="col-xs-12 col-sm-2">
						<span className="span-min">Fecha</span>
						<input type="date" name="start_date" id="start_date" value={this.state.start_date} 
							className="form-control hour-input" onChange={this.handleChange}/>
					</div>
					<div className="col-xs-12 col-sm-3">
						<span className="span-min">Lugar de Colecta</span>
						<select name="convoke_place" id="convoke_place" value={this.state.convoke_place} 
							className="form-control" onChange={this.handleChange}>
							<option value="">Seleccione...</option>
							{this.state.convoke_places.map((c, i)=>{
								return <option key={i} value={c.convoke_places.id}>
									{c.convoke_places.name}
								</option>
							})}
						</select>
					</div>
					<div className="col-xs-12 col-sm-2">
						<span className="span-min">Tipo de Extracción</span>
						<select name="extraction_type" id="extraction_type" value={this.state.extraction_type} 
							className="form-control" onChange={this.handleChange}>
							<option value="">Seleccione...</option>
							{this.state.extraction_types.map((e, i)=>{
								return <option key={i} value={e.id}>
									{e.donation_type_process}
								</option>
							})}
						</select>
					</div>
					<div className="col-xs-12 col-sm-2" style={{marginTop: "19px"}}>
						<button style={{fontSize:"15px", paddingTop:'1px', paddingBottom:'1px', marginRight:'8px'}} className="btn btn-info btn-search" type="button"
							onClick={this.onSearch}>
							<SvgIcon icon={search}/> | Buscar
						</button>
					</div>
				</div>

				{this.state.hours.map((h, i)=>{
					return <div className="col-xs-1" key={i}>
						<button className="btn" style={{margin:"5px", backgroundColor:h.color}} 
						onClick={e =>this.newEvent(e,h.start)} disabled={h.full || h.locked}>
							<span>{h.start +" - "+h.end}</span>
						</button>
					</div>
				})}
				
				<div className="col-xs-12">
					<div className="col-xs-12 col-sm-2" style={{padding:"5px"}}>
						<select className="form-control" name="hour" id="hour" value={this.state.hour} 
							onChange={this.handleChangeFilter}>
							<option value="all">Todos</option>
							{this.state.hours.map((h, i)=>{
								return <option key={i} value={i}>
									{h.start +" - "+h.end}
								</option>
							})}
						</select>
					</div>
				</div>
				<div className="col-xs-12">
					<Table responsive hover>
						<thead>
							<tr>
								<th hidden={this.showColumn('FOLIO')}>Folio</th>
								<th hidden={this.showColumn('DATE')}>Fecha</th>
								<th hidden={this.showColumn('HOUR')}>Hora</th>
								<th hidden={this.showColumn('EVENT')}>Evento</th>
								<th hidden={this.showColumn('STATUS')}>Estatus</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							{this.state.events.map((ev, i)=>(
								<tr key={i}>
									<td hidden={this.showColumn('FOLIO')}>{ev.folio}</td>
									<td hidden={this.showColumn('DATE')}>{ev.start}</td>
									<td hidden={this.showColumn('HOUR')}>{ev.hour}</td>
									<td hidden={this.showColumn('EVENT')}>{ev.title+' - '+ev.extraction_type+' - '+ev.donation_type}</td>
									<td hidden={this.showColumn('STATUS')}>{ev.status}</td>
									<td>
										{ev.status === "" ?
							        		<button className="btn btn-info" id={ev.id} 
							        			style={{marginRight:'8px'}}
							        			onClick={(e)=> this.onRegister(e)}>
							        			Registro
							        		</button>
							        	:null}
							        	{ev.status === "" ?
							        		<button className="btn btn-info btn-xs" title="Editar" style={{marginRight:"5px"}} 
												onClick={this.editPre.bind(this,ev.id)}>
												<SvgIcon icon={pencil2} size={24} />
											</button>
							        	: null}

							        	{ev.status === "" ?
							        		<button className="btn btn-info btn-xs" title="Editar" style={{marginRight:"5px"}} 
												onClick={this.deletePre.bind(this,ev.id)}>
												<SvgIcon icon={bin} size={24} />
											</button>
							        	: null}
							        	
									</td>
								</tr>

							))}
						</tbody>
					</Table>

				</div>

				<ModalNew {...this.props} onRef={ref => (this.modal_new = ref)} 
					getList={this.getList}
					convoke_place={this.state.convoke_place}
					extraction_type={this.state.extraction_type}
				/>
			</div>
		)
	}
}

export default translate('translations')(DiaryList);